import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

import LanguageSwitcher from "./language-switcher";

export default function Header(): React.JSX.Element {
  return (
    <AppBar position="static" sx={{ backgroundColor: "common.white" }}>
      <Container
        id="container-app-bar"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "auto",
          height: "57px",
        }}
      >
        <Link
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            marginTop: "6px",
            marginBottom: "6px",
            flexDirection: "row",
            justifyContent: "center",
            textDecoration: "none",
            gap: 1,
          }}
          to="/?updatePage=1"
        >
          <img
            alt="logo"
            src="/assets/logo.svg"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "90px",
            }}
            width="100%"
          />
        </Link>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <LanguageSwitcher />
          <Link
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              marginTop: "6px",
              marginBottom: "6px",
              flexDirection: "row",
              justifyContent: "center",
              textDecoration: "none",
              gap: 1,
            }}
            to="/?updatePage=1"
          >
            <img
              alt="logo"
              src="/assets/logo2.svg"
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "90px",
              }}
              width="100%"
            />
          </Link>
        </div>
      </Container>
    </AppBar>
  );
}

